import { useCallback } from 'react';
import { supabase } from '../lib/supabase';

export function useMaterials() {
  const getMaterials = useCallback(async ({ userId }) => {
    const { data, error } = await supabase
      .from('materials')
      .select('*')
      .eq('user_id', userId)
      .order('name', { ascending: true });
    if (error) throw error;
    return data || [];
  }, []);

  const createMaterial = useCallback(async (material) => {
    const { data, error } = await supabase.from('materials').insert(material).select().single();
    if (error) throw error;
    return data;
  }, []);

  const updateMaterial = useCallback(async (id, updates) => {
    const { data, error } = await supabase.from('materials').update(updates).eq('id', id).select().single();
    if (error) throw error;
    return data;
  }, []);

  const deleteMaterial = useCallback(async (id) => {
    const { error } = await supabase.from('materials').delete().eq('id', id);
    if (error) throw error;
  }, []);

  return { getMaterials, createMaterial, updateMaterial, deleteMaterial };
}
